import request from './index'

// 获取仪表盘统计数据
export function getStats() {
  return request({
    url: '/dashboard',
    method: 'get'
  })
}

// 更新系统周设置
export function updateWeek(data) {
  return request({
    url: '/dashboard/update-week',
    method: 'post',
    data
  })
}
